import Api from './Api'

export const attivitaApi = {
  heartbeat: () => Api.post('/attivita/heartbeat'),
  utenti: (da, a) => Api.get('/attivita/utenti', { da, a }),
  intraday: userId => Api.get('/attivita/intraday', { userId }),
  storico: ({ granularita, da, a, userId }) => Api.get('/attivita/storico', { granularita, da, a, userId })
}
